import * as React from 'react';

import { CommandBar, ICommandBarItemProps } from 'office-ui-fabric-react/lib/CommandBar';
import { Image } from 'office-ui-fabric-react/lib/Image';
import { Label } from 'office-ui-fabric-react/lib/Label';

import { Title } from 'enchoice-fabric-react-lib';

import Api from '../../../components/Api';

export interface IDocumentPreviewProps {
  id: number;
}

class DocumentPreview extends React.PureComponent<IDocumentPreviewProps, any> {
  constructor(props: IDocumentPreviewProps) {
    super(props);
    this.state = {
      properties: [],
      error: undefined
    };
  }

  public componentDidMount() {
    console.log('fetching: ', this.props.id);
    Api(`documents/${this.props.id}/default`)
      .then(response => {
        this.setState({
          properties: response.data.data
        });
      })
      .catch(errorValue => this.setState({ error: errorValue }));
  }
  /* 
  public componentDidUpdate() {
    console.log('fetching: ', this.props.id);
    fetch(`${URL_BASE}/${this.props.id}/default`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      }
    })
      .then(response => response.json())
      .then(response => {
        this.setState({
          properties: response.data
        });
      })
      .catch(errorValue => this.setState({ error: errorValue }));
  } */

  public render(): JSX.Element {
    const { properties } = this.state;
    return (
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <Image src="https://via.placeholder.com/500x400?text=Document+Preview" alt="Document Preview" />
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12" style={{ paddingTop: '20px' }}>
            <Title title="Document Properties" icon={true} />
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            {properties.map((element: any) => {
              const rowKey = 'row' + element.name;
              return (
                <div className="ms-Grid-row" key={rowKey}>
                  <div className="ms-Grid-col ms-sm4 ms-md4 ms-lg4">
                    <Label className="ms-font-m-plus" style={{ fontWeight: 'bold' }}>
                      {element.name}
                    </Label>
                  </div>
                  <div className="ms-Grid-col ms-sm8 ms-md8 ms-lg8">
                    <Label className="ms-font-m-plus">{element.value}</Label>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-sm12 ms-md12 ms-lg12">
            <CommandBar items={[]} farItems={this.getCommandBarFarItems()} />
          </div>
        </div>
      </div>
    );
  }

  private getCommandBarFarItems(): ICommandBarItemProps[] {
    const items: ICommandBarItemProps[] = [
      {
        key: 'Download',
        name: 'Download',
        iconProps: {
          iconName: 'DownloadDocument'
        },
        onClick: () => {
          console.log('Download');
        }
      }
    ];

    return items;
  }
}

export default DocumentPreview;
